{
  "version": 1,
  "asset_id": "bb757e6b-882b-4a08-ade6-52995a9d1850",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/bb757e6b-882b-4a08-ade6-52995a9d1850/exterior-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/bb757e6b-882b-4a08-ade6-52995a9d1850/exterior-hero.webp",
  "original_filename": "exterior-hero.webp",
  "size": 83530,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:25Z"
}
